// src/pages/About.js
import React from "react";
import { Link } from "react-router-dom";

const About = () => (
  <div className="page">
    <div className="container static-page">
      <div className="static-hero">
        <span className="hero__badge">Who We Are</span>
        <h1 className="static-hero__title">About <span className="hero__accent">Halro Images</span></h1>
        <p className="static-hero__sub">
          A free platform for discovering and downloading millions of stunning photos.
        </p>
      </div>

      <div className="static-content">
        <div className="static-card">
          <div className="static-icon">📸</div>
          <h2>Our Mission</h2>
          <p>
            Halro Images was built to give everyone — designers, bloggers, developers, creators —
            access to beautiful, high-resolution photography completely free of charge.
            No subscriptions. No hidden fees. No attribution required.
          </p>
        </div>

        <div className="static-card">
          <div className="static-icon">🌍</div>
          <h2>Powered by Pexels</h2>
          <p>
            All photos on Halro Images are sourced from <a href="https://www.pexels.com" target="_blank" rel="noopener noreferrer">Pexels</a> —
            one of the world's largest libraries of free stock photography.
            Every image is hand-picked and contributed by talented photographers worldwide.
          </p>
        </div>

        <div className="static-card">
          <div className="static-icon">⚡</div>
          <h2>What We Offer</h2>
          <ul className="static-list">
            <li>✓ Millions of free high-resolution photos</li>
            <li>✓ Download in 4 sizes — Original, Large, Medium, Small</li>
            <li>✓ Search by keyword or browse curated collections</li>
            <li>✓ Download history saved to your account</li>
            <li>✓ No watermarks, no copyright restrictions</li>
          </ul>
        </div>

        <div className="static-card">
          <div className="static-icon">🔒</div>
          <h2>Your Privacy Matters</h2>
          <p>
            We only collect what's necessary — your email and download history.
            We never sell your data to third parties.
            Read our full <Link to="/privacy">Privacy Policy</Link> for details.
          </p>
        </div>
      </div>

      <div className="static-cta">
        <h2>Ready to explore?</h2>
        <p>Browse millions of free photos right now.</p>
        <Link to="/" className="btn-primary">Browse Photos</Link>
      </div>
    </div>
  </div>
);

export default About;
